import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { HashRouter, Route, Routes } from "react-router-dom";
import { PanelPage } from "./Panel";
import { PanelExhibitionPage } from "./PanelExhibition";
import { PanelListPage } from "./PanelList";
export const RouterRoot = () => {
    return _jsx(HashRouter, { children: _jsxs(Routes, { children: [_jsx(Route, { path: "/panel/:panelId/exhibition", element: _jsx(PanelExhibitionPage, {}) }), _jsx(Route, { path: "/panel/:panelId", element: _jsx(PanelPage, {}) }), _jsx(Route, { path: "/", element: _jsx(PanelListPage, {}) })] }) });
};
